import Navbar from './components/Navbar';
import Hero from './components/Hero';
import SocialProof from './components/SocialProof';
import Pricing from './components/Pricing';
import FreeTrial from './components/FreeTrial';
import Benefits from './components/Benefits';
import Devices from './components/Devices';
import Catalogue from './components/Catalogue';
import Guarantee from './components/Guarantee';
import WhyChoose from './components/WhyChoose';
import WorldCoverage from './components/WorldCoverage';
import FAQ from './components/FAQ';
import Support from './components/Support';
import CTAFooter from './components/CTAFooter';
import StructuredData from '@/components/base/StructuredData';

const homeSchemas = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '4K Dream',
    url: 'https://www.4k-dream.com',
    description: 'Independent premium streaming service offering 25,000+ live channels and 70,000+ movies & series in HD/4K quality.',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.4k-dream.com/?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '4K Dream',
    url: 'https://www.4k-dream.com',
    logo: 'https://static.readdy.ai/image/5c7545dbb6198b28906c423b0244c4c9/0789dc6d730dd15b6f1e8e24be7c3580.webp',
    foundingDate: '2019',
    description: '4K Dream is an independent premium streaming service founded in 2019. We provide live TV channels, movies, and series in HD/4K quality to customers in 150+ countries.',
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+1-205-709-2376',
        contactType: 'customer support',
        availableLanguage: ['English', 'French', 'Arabic'],
        hoursAvailable: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
          opens: '10:00',
          closes: '00:00',
        },
      },
    ],
    sameAs: [
      'https://wa.me/12057092376',
    ],
    email: 'support@4k-dream.com',
    telephone: '+1-205-709-2376',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: '4K Dream Premium Streaming',
    provider: {
      '@type': 'Organization',
      name: '4K Dream',
      url: 'https://www.4k-dream.com',
    },
    serviceType: 'Streaming Service',
    description: 'Premium live TV streaming service with 25,000+ channels and 70,000+ movies & series in HD/4K quality.',
    areaServed: {
      '@type': 'Place',
      name: 'Worldwide',
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Streaming Subscription Plans',
      itemListElement: [
        {
          '@type': 'Offer',
          name: 'Premium 1 Month',
          price: '14',
          priceCurrency: 'USD',
          description: 'Premium streaming subscription — 1 month access to 25,000+ HD/4K channels and 35,000+ movies & series.',
        },
        {
          '@type': 'Offer',
          name: 'Premium Gold 1 Month',
          price: '17',
          priceCurrency: 'USD',
          description: 'Premium Gold streaming subscription — 1 month access to 35,000+ 4K channels and 70,000+ movies & series with Anti-Freeze technology.',
        },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'How does your streaming service work?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'After subscribing, you receive your login credentials within 5 minutes. You can then install our app on any compatible device and start watching thousands of live channels and an extensive library of movies & series instantly.',
        },
      },
      {
        '@type': 'Question',
        name: 'Which devices can I use the service on?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Our service is compatible with Smart TV (Samsung, LG, Sony), Android TV, Amazon Fire Stick, smartphones (iOS & Android), tablets, and computers (Windows, Mac, Linux).',
        },
      },
      {
        '@type': 'Question',
        name: 'How does the free 24h trial work?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Simply contact us via WhatsApp or fill out the form. We activate your free 24-hour trial within minutes — no credit card required, no commitment.',
        },
      },
      {
        '@type': 'Question',
        name: 'What is your refund policy?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We offer a 7-day money-back guarantee. If you are not satisfied within the first 7 days of your subscription, contact us and we will issue a full refund — no questions asked.',
        },
      },
      {
        '@type': 'Question',
        name: 'What internet speed is required?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We recommend at least 10 Mbps for HD quality and 25 Mbps for 4K Ultra HD streaming. A stable connection ensures the best experience.',
        },
      },
      {
        '@type': 'Question',
        name: 'How long does activation take?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Activation is instant — you receive your credentials within 5 minutes of payment confirmation.',
        },
      },
    ],
  },
];

const HomePage = () => (
  <div className="min-h-screen bg-black text-white">
    <StructuredData schemas={homeSchemas} id="home" />
    <Navbar />
    <main>
      <Hero />
      <SocialProof />
      <Pricing />
      <FreeTrial />
      <Benefits />
      <Devices />
      <Catalogue />
      <Guarantee />
      <WhyChoose />
      <WorldCoverage />
      <FAQ />
      <Support />
    </main>
    <CTAFooter />
  </div>
);

export default HomePage;
